import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IMatch } from 'src/app/shared/models/IMatch.model';
import { HelpersService }   from '@evento-ng/libs';

@Component({
  selector: 'app-match-header',
  templateUrl: './match-header.component.html',
  styleUrls: ['./match-header.component.scss'],
})
export class MatchHeaderComponent {
  @Input() matchInfo?: IMatch;

  public isMenuCollapsed = true;
  isMobile = false;
  constructor(
    public helpers: HelpersService,
    public translate: TranslateService
  ) {
    if (window.screen.width < 786) {
      this.isMobile = true;
    }
  }
}
